import { UseCurrentSPIProvider } from 'components/widgets/CurrentSPI/CurrentSPI.provider';
import { getValueClassName } from 'components/widgets/CurrentSPI/CurrentSPI.utils';

interface Props {
    api: UseCurrentSPIProvider['api'];
}

export const useCurrentSPILogic = ({ api }: Props) => {
    const value = api.getCurrentSPI.instance.data?.value;
    const threshold = api.getCurrentSPI.instance.data?.threshold;

    const calculatedValue = api.getCurrentSPI.instance.data?.value ? api.getCurrentSPI.instance.data?.value : 'N/A';

    return {
        logic: {
            valueClassName: getValueClassName(value, threshold),
            calculatedValue,
        },
    };
};
